import { render, staticRenderFns } from "./ReceivingWallet.vue?vue&type=template&id=4b97b271&scoped=true"
import script from "./ReceivingWallet.vue?vue&type=script&lang=js"
export * from "./ReceivingWallet.vue?vue&type=script&lang=js"
import style0 from "./ReceivingWallet.vue?vue&type=style&index=0&id=4b97b271&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b97b271",
  null
  
)

export default component.exports